import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import withRouter from 'src/components/withRouter';
import PageCardsContainer from 'src/components/PageCardsContainer';
import Back from '../Back';
import Header from '../Header';
import LandsSelect from '../LandsSelect';
import RentalCard from './components/RentalCard';
import RentalsViewModel from './viewModel';
import styles from './styles.module.scss';

@observer
class Rentals extends React.Component {
  constructor(props) {
    super(props);
    this.vm = new RentalsViewModel({ router: props.router });
  }

  componentDidMount() {
    this.vm.didMount();
  }

  render() {
    return (
      <>
        <Back />

        <Header subtitle={this.vm.labels.subTitle} />

        <LandsSelect
          value={this.vm.landId}
          onChange={this.vm.onLandIdChange}
          disabled={this.vm.disabled.landId}
          showSearch
          optionFilterProp="label"
        />

        <PageCardsContainer
          paddingBottom
          onWaypointEnter={this.vm.onWaypointEnter}
        >
          {this.vm.rentals.map((item) => (
            <RentalCard vm={item} key={item.id} />
          ))}
        </PageCardsContainer>
      </>
    );
  }
}

Rentals.propTypes = {
  router: PropTypes.object.isRequired
};

Rentals.defaultProps = {};

export default withRouter(Rentals);
